<template>
    <div class="setDate-menu">
        <scrollbar class="setDate-menu-wrap" :style="'margin-right:' + widthRight + 'px'">
            <!--<div class="setDate-menu-title">
                <div class="setDate-menu-closeIcon">
                    <i class="mdi mdi-window-close"></i>
                </div>
            </div>-->
            <div class="setDate-menu-week">
                <div class="setDate-menu-row">
                    <div class="setDate-menu-itemTitle">Число</div>
                    <div class="setDate-menu-itemTitle">% Дохода</div>
                    <div class="setDate-menu-itemTitle">Отчет</div>
                </div>
                <div class="setDate-menu-row" v-for="(item,index) in daysData" :key="index">
                    <div class="setDate-menu-item">{{new Date(item.Date).getDate()}}</div>
                    <div class="setDate-menu-item" :class="100-(100/(item.EquityClose/item.EquityOpen)) < 0 ? 'color-red':'color-green'">{{(100-(100/(item.EquityClose/item.EquityOpen))).toFixed(2)}}%</div>
                    <div class="setDate-menu-item">
                        <i  @click="setDateReport(item)" class="icon-blog"></i>
                    </div>
                </div>
            </div>
        </scrollbar>
        <scrollbar>
            <reportWidget v-if="dayDataForReport !== null" :dayData="dayDataForReport" @close="closeReport"/>
        </scrollbar>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
// import axios from "axios";
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import reportWidget from './reportDays'
export default {
    props: ['daysData',],
    components: {
       "scrollbar":VuePerfectScrollbar,
       reportWidget
    },
    data() {
        return {
           dayDataForReport:null,
           widthRight:331
        }
    },
    computed: {
        ...mapGetters({
        
        }),
    },
    methods: {
        setDateReport(data) {
            this.dayDataForReport = data;
            this.widthRight = 0;
        },
        closeReport() {
           this.dayDataForReport = null; 
           this.widthRight = 331;
        },
        closeMenu() {
            this.$emit('closeMenu', false);
        },
    },
    created() {
       
    }
}


</script>
<style lang="less" scoped>
.setDate-menu {
    position: absolute;
    top:40px;
    right: 10px;
    z-index: 4;
    display: flex;
    height: 100%;
    width: 100%;
    justify-content: flex-end;
    align-items: start;
    //max-height: 400px;
    overflow: auto;
    &-select {
        display: flex;
        justify-content: center;
        padding: 4px;
        font-size: 12px;
        font-family: 'Arimo';
        font-weight: 700;
        text-align: center;
        width: 60px;
        color: #fff;
        //line-height: 1.3;
        //padding: .6em 1.4em .5em .8em;s
        box-sizing: border-box;
        margin: 0;
        -moz-appearance: none;
        -webkit-appearance: none;
        appearance: none;
        border: 1px #324258 solid;
        background-color: #324258;
        outline: none;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAAZiS0dEAAAAAAAA+UO7fwAAAAlwSFlzAAAASAAAAEgARslrPgAAAHRJREFUSMftj7ENwkAQBEeGdlyOM/og9LsTR5RIYktDYIJH4j4wn3ET783eQpIkTdSxRyY6XNRdvTUyk7qpJcoMjY4ncAHWbyXqBDyAK+DZFXcPPpZUn6vOp+RRSVd5VVLewq2Sl5/FwZJ+nwdL+n6eJH/AC2fFjaeFV0LKAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE5LTA1LTE1VDEyOjA2OjM2KzAwOjAwCnWQQwAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOS0wNS0xNVQxMjowNjozNiswMDowMHsoKP8AAAAodEVYdHN2ZzpiYXNlLXVyaQBmaWxlOi8vL3RtcC9tYWdpY2stdjVmTzZzMVpzK/ieAAAAAElFTkSuQmCC');
        background-repeat: no-repeat, repeat;
        background-position: right .1em top 50%, 0 0;
        background-size: 1.65em auto, 100%;
        &:active {
            background-color:#324258;
            outline: none;
            padding: 4px;
            border: 1px #324258 solid;
        }
    }
    &-row {
        display: flex;
        border-top:1px solid #324258;
        height: 28px;
        border-bottom: 1px solid #293546;
        cursor: pointer;
        &:last-child {
            border-bottom:none;
        }
    }
    &-item {
        flex-basis: 50%;
        flex-grow: 1;
        text-align: center;
        font-family: 'Arimo';
        font-weight: 600;
        font-size: 13px;
        border-right: 1px solid #293546;
        &:last-child {
           border-right: none; 
        }
        display: flex;
        align-items: center;
        justify-content: center;
    }
    &-itemTitle {
        font-family: 'Arimo';
        font-weight: 600;
        text-transform: uppercase;
        font-size: 11px;
        color:#9FB6D2;
        flex-basis: 50%;
        flex-grow: 1;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    &-title {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 30px;
        padding:8px;
        box-sizing: border-box;
        background-color: #324258;
        border-bottom: 1px solid #293546;
        font-size: 12px;
        text-align: center;
        text-transform: uppercase;
        font-family: 'Arimo';
        color:#9FB6D2;
    }
    &-wrap {
        min-width:220px;
        background: #324258;
        //height: 500px;
        //display: flex;
        //justify-content: space-between;
        //margin-bottom: 8px;
    }
    &-icon {
        height: 100%;
        font-size: 18px;
        margin-left: auto;
        padding-right: 12px;
        cursor: pointer;
    }
    &-closeIcon {
        text-align: right;
        font-size: 15px;
        color:#fff;
        i {
            cursor: pointer;
        }
    }
    &-month {
        margin-right: 12px;
    }
    &-year {
        margin-right: 12px;
        display: flex;
        width:100%;
    }
    &-button {
        width:100%;
        display: flex;
        justify-content: center;

        input[type="button"] {
            width: 80px;
            border-radius: 4px;
            padding: 8px;
            background-color: #0fd7b7;
            border: none;
            color: #374b62;
            cursor: pointer;
            font-family: Arimo;
            font-size: 12px;
            font-weight: bold;
        }
    }
}
</style>

